import { Description, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardText, CardTitle, Col, Row } from "reactstrap";
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";
import usePayment from "../../hooks/user/usePayment";
import "./UserPaymentsStyles.css";

function UserPaymentsView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Medios de pago', href: '' }
    ];

    const navigateHk = useNavigate();
    const paymentHk = usePayment();

    const [paymentMethods, setPaymentMethods] = useState([]);


    let [isOpen, setIsOpen] = useState(true);


    useEffect(() => {
        const fetchAsyncData = async () => {
            await loadPaymentMethods();
        }
        fetchAsyncData();
    }, []);

    const loadPaymentMethods = async () => {
        setPaymentMethods(await paymentHk.readAll());
    }

    const btnAddClick = () => {
        navigateHk("/user/payments/create");
    };



    const btnDeleteClick = async (id) => {
        setIsOpen(true);


        let payment = paymentMethods.find(item => item.id = id);
        let status = await paymentHk.deletePayment(payment);
        if (status) {
            alert("DELETED");
            await loadPaymentMethods();
        }
        else
            alert("failed");
    }


    const btnEditClick = async (id) => {
        navigateHk("/user/payments/edit/" + id);
        //TODO navigate to edit
    }



    return (
        <>

            <MainPageComponent requireAuthentication={true} path={breadcrumbPath}>
                <CenterCenterVerticalContainer>
                    <Row>
                        <Col className="col-6">
                            <h1>Medios de pago</h1>
                        </Col>
                        <Col>
                            <Button className="create-button plus-button" onClick={btnAddClick}><strong>+</strong></Button>
                        </Col>
                    </Row>
                    <Row>
                        {paymentMethods.map((method, key) => {
                            return (
                                <Col key={method.id} className="payment-card" sm="6" md="4" lg="3" xl="2">
                                    <Card body>
                                        <CardTitle tag="h5">
                                            {method.name}
                                        </CardTitle>
                                        <CardText>
                                            {method.description}
                                        </CardText>
                                        <Row>
                                            <Col className="col-6">
                                                <Button className="edit-button" onClick={() => { btnEditClick(method.id) }}>
                                                    Editar
                                                </Button>
                                            </Col>
                                            <Col className="col-6">
                                                <Button className="delete-button" onClick={() => { btnDeleteClick(method.id) }} >
                                                    Eliminar
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </CenterCenterVerticalContainer>




            </MainPageComponent>

            <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
                <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                    <DialogPanel className="max-w-lg space-y-4 border bg-white p-12">
                        <DialogTitle className="font-bold">Deactivate account</DialogTitle>
                        <Description>This will permanently deactivate your account</Description>
                        <p>Are you sure you want to deactivate your account? All of your data will be permanently removed.</p>
                        <div className="flex gap-4">
                            <button onClick={() => setIsOpen(false)}>Cancel</button>
                            <button onClick={() => setIsOpen(false)}>Deactivate</button>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </>
    );
}

export default UserPaymentsView;